import React from 'react';
import Image from 'next/image';

export default function Img({ image, width, height, noImage = true, layout }) {
  return (
    <>
      {image ? (
        <Image
          className="w-full rounded-md"
          src={image.full_path}
          width={width}
          height={height}
          alt={image.alt}
          title={image.name}
        />
      ) : (
        <>
          {noImage && (
            <Image
              src="/images/no-image.jpg"
              width={width}
              height={height}
              alt="no image"
            />
          )}
        </>
      )}
    </>
  );
}
